<template>
  <div
    :class="containerClasses"
    class="row main py-2"
  >
    <div
      v-if="!reverse"
      class="flex image-container "
      :class="imageContainerClasses"    
    >
      <div class="animated-image mr-3 ml-0" />
    </div>
    <div class="flex-grow-1 " :class="textContainerClasses"
    >
      <div class="animated-text mb-4 ml-0">
        <div 
          v-for="(i, index) in new Array(textLine || 3)" 
          :key="i"
          :style="!textLine ? { width: textLineWidth(index)}:{}"
          class="animated-text-line mb-3" />
      </div>
      <div v-if="propertyLine">
        <div
          v-for="i in new Array(propertyLine)"
          :key="i"
          class="row mb-2"
        >
          <div class="col-md-4">
            <div class="animated-text-line" />
          </div>
          <div class="col-md-5">
            <div class="animated-text-line" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="reverse"
      class="flex"
    >
      <div class="animated-image" />
    </div>
  </div>
</template>
<script>
export default {
	name: "InfoBlockLoader",
	components: {},
	props: {
		infoType: {
			type: String,
		},
		textLine: {
			type: Number,
		},
		propertyLine: {
			type: Number,
		},
		reverse: {
			type: Boolean,
		},
	},
	computed: {
		containerClasses() {
			return {
				profileBlock: this.infoType === "userProfile",
				"eventBlock justify-content-between": this.infoType === "event",
				main: this.infoType === "userProfile",
			}
		},
		imageContainerClasses() {
			return {
				"col-md-4 mb-4": this.infoType === "userProfile",
				"col-lg-7 col-xl-4 mb-4": this.infoType === "event",
			}
		},
		textContainerClasses() {
			return {
				"my-3 ml-4": this.infoType === "userProfile",
				"col-lg-5 col-xl-7": this.infoType === "event",
			}
		},
	},
	methods: {
		textLineWidth(index) {
			if (index === 0) {
				return "85%"
			}
			if (index === 1) {
				return "60%"
			}
			if (index === 2) {
				return "80%"
			}
		},
	},
}
</script>
<style lang="scss" scoped>
  .profileBlock.main{
    height: 600px;
  }

  .profileBlock .image-container{
    max-width: 18rem;
  }
  .profileBlock .animated-image{
    max-width: 100%;
    max-height: 100%;
    width: 212px;
    height: 290px;
  }

  .eventBlock .animated-image{
    max-width: 100%;
    max-height: 100%;
    width: 342px;
    height: 330px;
}
.eventBlock .animated-text{
  margin-left: 0;
}

  .animated-text-line{
    height: 20px;
  }


</style>